import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { useAuthStore } from '@/modules/shared/stores/auth.store'
import { getComparativeReportService } from '../services/get-comparative-report.service'
import type { ComparativePeriod } from '../types/comparative-report.type'

export function useComparativeReport() {
  const [period, setPeriod] = useState<ComparativePeriod>(() => {
    const today = new Date()
    return {
      ano: String(today.getFullYear()),
      mes: String(today.getMonth() + 1),
    }
  })
  const [draftPeriod, setDraftPeriod] = useState(period)
  const user = useAuthStore((state) => state.user)
  const versionUrl = useAuthStore((state) => state.versionUrl)
  const query = useQuery({
    queryKey: [
      'comparative-report',
      versionUrl,
      user?.id,
      period.ano,
      period.mes,
    ],
    queryFn: ({ signal }) => getComparativeReportService(period, signal),
    refetchOnWindowFocus: false,
    retry: 1,
  })

  function search() {
    if (period.ano === draftPeriod.ano && period.mes === draftPeriod.mes) {
      void query.refetch()
    } else {
      setPeriod({ ...draftPeriod })
    }
  }

  return { ...query, period, draftPeriod, setDraftPeriod, search }
}
